// Helper to normalize text by removing HTML tags, decoding entities and normalizing whitespace
export const normalizeText = (text: string | null | undefined): string => {
  if (!text || text.trim() === '') return '';

  let cleaned = text.trim();

  // Remove quotes around HTML tags
  cleaned = cleaned.replace(/(<[^>]+>)"/g, '$1');
  cleaned = cleaned.replace(/"(<\/[^>]+>)/g, '$1');

  // Remove HTML comments
  cleaned = cleaned.replace(/<!--[\s\S]*?-->/g, '');

  // Remove HTML tags
  cleaned = cleaned.replace(/<[^>]*>/g, '');

  // Decode HTML entities
  cleaned = cleaned
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&nbsp;/g, ' ')
    .replace(/&#(\d+);/g, (_match, dec) => String.fromCharCode(dec))
    .replace(/&#x([0-9a-f]+);/gi, (_match, hex) => String.fromCharCode(parseInt(hex, 16)));

  // Normalize whitespace
  cleaned = cleaned
    .replace(/[\n\r\t]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return cleaned;
};
